import React from 'react';

const DropdownTriggerIcon = ({ className = '', ...props }) => (
  <span className={`dropdown-trigger-icon ${className}`} {...props}>
    {/* Modern vertical ellipsis SVG */}
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="4.5" r="1.5" fill="#6B7280"/>
      <circle cx="11" cy="11" r="1.5" fill="#6B7280"/>
      <circle cx="11" cy="17.5" r="1.5" fill="#6B7280"/>
    </svg>
  </span>
);

export default DropdownTriggerIcon; 